import groq from 'groq';

import { ASSET } from './asset';

export const BACKGROUND = groq`
  image {
    ${ASSET},
    hotspot,
    crop
  },
  overlayColor {
    hex
  },
  gradientOverlay {
    desktop,
    mobile
  }
`;
